<template>
  <div>
    <!-- New vocabulary  -->
    <div class="d-flex">
      <h4 class="my-2">新出語彙</h4>
      <v-spacer />
      <AddVocabulary @resetList="keyVocabularyList++" />
    </div>
    <div>
      <v-chip
        class="ma-2"
        v-for="(vocabulary, index) in vocabularySentence"
        :key="keyVocabularyList + index"
      >
        <span class="ml-3" style="white-space: pre-wrap">{{
          vocabulary["ja"]
        }}</span>
        <UpdateVocabulary
          :item="vocabulary"
          :index="index"
          @resetList="keyVocabularyList++"
        />
        <VocabularyDelete :index="index" @resetList="keyVocabularyList++" />
      </v-chip>
    </div>
  </div>
</template>
<script>
import AddVocabulary from "./AddVocabulary";
import VocabularyDelete from "./DeleteItemVocabulary";
import UpdateVocabulary from "./UpdateVocabulary";
// import { getListVocabulary } from "@/api/Vocabulary.api";
export default {
  store: ["vocabularySentence"],
  components: {
    AddVocabulary,
    VocabularyDelete,
    UpdateVocabulary,
  },
  data() {
    return {
      keyVocabularyList: 0,
    };
  },
};
</script>
<style scoped>
::v-deep .v-chip.v-size--default {
  height: auto;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>